export { default as categoryApi } from './category';
export { default as locationApi } from './location';
export { default as productApi } from './product';
export { default as newsApi } from './news';
export { default as partnerApi } from './partner';
export { default as bannerApi } from './banner';
export { default as clientApi } from './client';
export { default as userApi } from './user';
export { default as documentApi } from './document';
export { default as productPriceApi } from './productPrice';
export { default as productPriceProposalApi } from './productPriceProposal';
